export module Settings {
	export const PAGINATION_DEFAULT_TAKE = 50;
	export const PAGINATION_DASHBOARD_TAKE = 15;
}
